export default "__VITE_ASSET__BZrXhO9W__"